// extracted by mini-css-extract-plugin
module.exports = {"icon":"ServiceOneBadge_icon__2MQPp"};